import { PublicRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { ActionButton } from '@pages/ActionButton';
import { scheduleSettings } from '@stores/ScheduleSettings';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { TimeZoneDialog } from './TimeZoneDialog';

/** The schedule header's way into the time zone dialog, worded with the zone in effect and its offset at `now`. */
export const TimeZoneButton = observer(function TimeZoneButton({ now }: { now: Date }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Tooltip
        title={`Times are in ${scheduleSettings.timeZoneLabel(now.getTime())}. Click to change.`}
      >
        <ActionButton
          variant="secondary"
          aria-label="Change time zone"
          onClick={() => setOpen(true)}
        >
          <PublicRounded />
          &nbsp;{scheduleSettings.timeZoneLabel(now.getTime(), 'short')}
        </ActionButton>
      </Tooltip>
      <TimeZoneDialog open={open} onClose={() => setOpen(false)} source="schedule" />
    </>
  );
});
